/* eslint-disable */
export const ease = options => new Easer(options)

export const EaserOptions = {
    delay: 0,
    duration: 300,
    autoStart: true,
    easing: 'easingFnLinear',
    onBegin: (progress, sender) => {},
    onComplete: (progress, sender) => {},
    onStop: (progress, sender) => {},
    onTick: (progress, sender) => {},
}

export const EaserStates = {
    idle: 'idle',
    running: 'running',
    stopped: 'stopped'
}

export const easingFnLinear = (t) => t
export const easingFnInSin = (t) => 1 + Math.sin(Math.PI / 2 * t - Math.PI / 2)
export const easingFnOutSin = (t) => Math.sin(Math.PI / 2 * t)
export const easingFnInOutSin = (t) => (1 + Math.sin(Math.PI * t - Math.PI / 2)) / 2
export const easingFnInQuad = (t) => t * t
export const easingFnOutQuad = (t) => t * (2 - t)
export const easingFnInCubic = (t) => t * t * t
export const easingFnOutCubic = (t) => (--t) * t * t + 1
export const easingFnInQuint = (t) => t * t * t * t
export const easingFnOutQuint = (t) => 1 + (--t) * t * t * t * t
export const easingFnOutExpo = (t) => t === 1 ? t : -Math.pow(2, -10 * t) + 1
export const easingFnBezier = (t) => BezierEasing(0.25, 0.8, 0.25, 1)(t)
export const easingFnOutBounce = (t) => {
    const c1 = 1.70158;
    const c3 = c1 + 1;

    return 1 + c3 * Math.pow(t - 1, 3) + c1 * Math.pow(t - 1, 2);
}
export const easingFnInBounce = (t) => {
    const c1 = 1.70158;
    const c3 = c1 + 1;

    return t === 1 ? 1 : c3 * t * t * t - c1 * t * t;
}

export const EasingFunctions = {
    easingFnLinear,
    easingFnInSin,
    easingFnOutSin,
    easingFnInOutSin,
    easingFnInQuad,
    easingFnOutQuad,
    easingFnInCubic,
    easingFnOutCubic,
    easingFnInQuint,
    easingFnOutQuint,
    easingFnOutExpo,
    easingFnBezier,
    easingFnInBounce,
    easingFnOutBounce
}


class Easer {
    constructor (options) {
        this.options = Object.assign(Object.assign({}, EaserOptions), options)
        this.created = window.performance.now()
        this.elapsed = 0
        this.progress = 0
        this.state = EaserStates.idle

        if (this.options.autoStart) {
            this.run()
        }
    }

    run () {
        if (this.state !== EaserStates.idle) {
            return
        }

        if (this.options.delay) {
            setTimeout(() => {
                this.options.delay = 0
                this.run()
            }, this.options.delay)
            return
        }

        this.state = EaserStates.running
        this.started = window.performance.now()
        this.options.onBegin(this.progress, this)
        this.tick()
    }

    stop () {
        this.state = EaserStates.stopped
        this.options.onCancel(this.progress, this)
    }

    tick () {
        if (this.state !== EaserStates.running) {
            return
        }

        this.elapsed = window.performance.now() - this.started - this.options.delay
        this.progress = this.getEasingFn(this.options.easing)(Math.min(this.elapsed / this.options.duration, 1))
        this.options.onTick(this.progress, this)

        if (this.progress === 1) {
            this.state = EaserStates.stopped
            this.options.onComplete(1, this)
            return
        }
        
        requestAnimationFrame(this.tick.bind(this))
    }

    getEasingFn (name) {
        return EasingFunctions[name] || EasingFunctions.easingFnLinear
    }
}